import { Text, VStack, Box, Grid } from '@chakra-ui/react'

import { Image } from '@/features/landing/components/OurTeam'

export interface TextWithImageProps {
  title: string
  paragraph: React.ReactNode
  image: string | StaticImageData
  imageRatio: number
}

function TextWithImage({
  title,
  paragraph,
  image,
  imageRatio,
}: TextWithImageProps): React.ReactElement {
  return (
    <Box
      as="section"
      sx={{
        bg: 'secondary.800',
        w: 'full',
        overflow: 'hidden',
      }}
    >
      <Grid
        layerStyle="container"
        sx={{
          gridTemplateColumns: {
            base: '1fr',
            md: '1fr 1fr',
          },
          alignItems: 'center',
          // gridGap: {
          //   base: 4,
          //   md: 10,
          // },
          color: 'white',
        }}
      >
        <Image
          image={image}
          ratio={imageRatio}
          sx={{
            mx: 12,
            gridRow: 1,
            maxW: '510px',
            gridColumn: { base: 1, md: 2 },
          }}
        />
        <VStack
          as="article"
          spacing="0"
          sx={{
            alignItems: { base: 'center', md: 'flex-start' },
          }}
        >
          <Text
            textStyle="landingSectionTitle"
            // sx={{
            //   display: {
            //     base: 'none',
            //     md: 'block',
            //   },
            // }}
          >
            {title}
          </Text>
          {paragraph}
        </VStack>
      </Grid>
    </Box>
  )
}

export default TextWithImage
